export default {
  '-2004': '请求参数出错',

  // PassLogin
  22002: '登录的账户权限非预期，请确认账户重试',
  // CreateFlow
  27160: '所属应用不存在',
  27161: '流程名称不能为空',
  27162: 'git地址不能为空',
  27163: '输入的文件夹路径为空',
  27164: '输入的文件夹路径重复',
  27165: '输入的流程名称重复',
  27166: '请确认填写的git是否正确',
  27167: '请确认填写的文件夹是否存在git地址中',

  // CreateProject
  27100: '项目名不能为空',
  27101: '项目类型不能为空',
  27102: '项目名不能重复',
  27103: '微信APPID不能为空',
  27104: '微信小程序名称不能为空',
  27105: '主应用模板在数据库中不存在',
  27106: '主应用模板编号非法',
  27107: '选择的应用模板并不是主应用模板',

  // EditAppType2
  27120: '应用模板为空',
  27121: '应用模板已在数据库中存在',
  27122: '请求参数错误',
  27123: '请求参数错误',

  // CreateAppInst
  27140: '版本不能为空',
  27141: '不符合语义化版本规则',

  // UpdateAppInstFlow
  27180: '请求参数错误',
  27181: '该流程模板已存在',
  27182: '找不到该流程模板',

  // UpdateAppInstPage
  27200: '请求参数错误',
  27201: '找不到该页面模板',

  // DeriveAppInst
  27220: '基础版本不符合语义化版本规则',
  27221: '版本不符合语义化版本规则',
  27222: '找不到该应用',
  27223: '找不到基础版本',
  27224: '该版本已存在',
  27225: '当前不能添加新的版本',
  27226: '新增的版本号应大于基础版本',

  // SendAppInstToDevs
  27240: '版本不能为空',
  27241: '版本不符合语义化版本规则',
  27242: '找不到该应用',
  27243: '找不到该版本',

  // SubmitInst
  27260: '找不到该应用',
  27261: '找不到该版本',

  // AuditInst
  27280: '状态参数错误',
  27281: '找不到该应用',
  27282: '找不到该版本',
  27283: 'AuditInst_Status_DBCheckFailed',

  // UpCreateMp2Inst
  27300: '请求参数错误',
  27301: '找不到该版本',
  27302: '找不到该项目',
  27303: '版本已存在',

  // UpFlow
  27320: '状态参数错误',

  // 2.0
  25302: '该版本已存在',
};
